module.exports = __webpack_public_path__ + "img/overseas_4.ca2f141c.jpg";